import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module easy-image/cloudservicesuploadadapter
*/
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import UploadGateway from '@ckeditor/ckeditor-cloud-services-core/src/uploadgateway/uploadgateway';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
/**
 * A plugin that enables upload to [CKEditor Cloud Services](https://ckeditor.com/ckeditor-cloud-services/).
 *
 * It is mainly used by the {@link module:easy-image/easyimage~EasyImage} feature.
 *
 * After enabling this adapter you need to configure the CKEditor Cloud Services integration through
 * {@link module:cloud-services/cloudservices~CloudServicesConfig `config.cloudServices`}.
 *
 * @extends module:core/plugin~Plugin
 */

var CloudServicesUploadAdapter =
/*#__PURE__*/
function (_Plugin) {
  _inherits(CloudServicesUploadAdapter, _Plugin);

  function CloudServicesUploadAdapter() {
    _classCallCheck(this, CloudServicesUploadAdapter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CloudServicesUploadAdapter).apply(this, arguments));
  }

  _createClass(CloudServicesUploadAdapter, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var cloudServices = editor.plugins.get(CloudServices);
      var token = cloudServices.token;
      var uploadUrl = cloudServices.uploadUrl;

      if (!token) {
        return;
      }

      this._uploadGateway = new CloudServicesUploadAdapter._UploadGateway(token, uploadUrl);

      editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
        return new Adapter(_this._uploadGateway, loader);
      };
    }
  }], [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [FileRepository, CloudServices];
    }
  }]);

  return CloudServicesUploadAdapter;
}(Plugin);
/**
 * @private
 */


export { CloudServicesUploadAdapter as default };

var Adapter =
/*#__PURE__*/
function () {
  function Adapter(uploadGateway, loader) {
    _classCallCheck(this, Adapter);

    this.uploadGateway = uploadGateway;
    this.loader = loader;
  }

  _createClass(Adapter, [{
    key: "upload",
    value: function upload() {
      var _this2 = this;

      return this.loader.file.then(function (file) {
        _this2.fileUploader = _this2.uploadGateway.upload(file);

        _this2.fileUploader.on('progress', function (evt, data) {
          _this2.loader.uploadTotal = data.total;
          _this2.loader.uploaded = data.uploaded;
        });

        return _this2.fileUploader.send();
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      this.fileUploader.abort();
    }
  }]);

  return Adapter;
}(); // Store the API in static property to easily overwrite it in tests.
// Too bad dependency injection does not work in Webpack + ES 6 (const) + Babel.


CloudServicesUploadAdapter._UploadGateway = UploadGateway;